const warnedUnsafeApiBases = new Set<string>();

export function sanitizeApiBase(raw?: string | null): string {
  if (!raw) {
    return '';
  }
  const trimmed = raw.trim();
  if (!trimmed || trimmed === '/') {
    return '';
  }
  return trimmed.replace(/\/+$/, '');
}

export function warnIfUnsafeApiBase(base: string, context: string): void {
  if (!base) {
    return;
  }

  // Only warn for absolute URLs; relative paths are always safe.
  if (!/^https?:\/\//i.test(base)) {
    return;
  }

  try {
    const parsed = new URL(base);
    const host = parsed.hostname.toLowerCase();
    // Browsers treat localhost/127.0.0.1 with differing ports as distinct origins → CORS.
    if (host !== 'localhost' && host !== '127.0.0.1') {
      return;
    }

    const key = `${context}:${parsed.origin}`;
    if (warnedUnsafeApiBases.has(key)) {
      return;
    }
    warnedUnsafeApiBases.add(key);

    const message =
      `[api-base] ${context} resolved to ${parsed.origin}. ` +
      'Browser requests will hit a different origin and trigger CORS preflight failures. ' +
      'Remove this override or use the same-origin proxy (leave VITE_API_BASE unset).';
    // eslint-disable-next-line no-console
    console.warn(message);
  } catch {
    // Ignore URL parse errors and fall back silently.
  }
}

